export default "__VITE_ASSET__92974bed__"